import Logo from './sources/logo.png'
import BgHero from './sources/bg_hero.png'
import BgHeroBig from './sources/bg_hero@2x.png'
import BgHeroMob from './sources/bg_hero_mob.png'
import BgHeroMobBig from './sources/bg_hero_mob@2x.png'
import About from './sources/about.png'
import AboutBig from './sources/about.png'
import Petrol from './sources/petrol.png'
import Gas from './sources/gas.png'
import Diesel from './sources/diesel.png'
import Certificate from './sources/certificate.png'
import Map from './sources/map.png'
import MapMob from './sources/map_mob.png'
import Bonuse from './sources/bonuse.png'
import BonuseMob from './sources/bonuse_mob.png'
import Barcode from './sources/barcode.png'
import BarcodeMob from './sources/barcode_mob.png'
import App from './sources/app_store.png'
import Google from './sources/google_play.png'
import CerfOne from './sources/cerf_one.jpg'
import CerfTwo from './sources/cerf_two.jpg'
import CerfThree from './sources/cerf_three.jpg'


export const Png = {
  Logo,
  BgHero,
  BgHeroBig,
  BgHeroMob,
  BgHeroMobBig,
  About,
  AboutBig,
  Petrol,
  Gas,
  Diesel,
  Certificate,
  Map,
  MapMob,
  Bonuse,
  BonuseMob,
  Barcode,
  BarcodeMob,
  App,
  Google,
  CerfOne,
  CerfTwo,
  CerfThree
}
